import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
/**
 * Simple overlay shown when the user switches to a source that can't be played
 * in the browser (e.g. ProRes original) but a proxy is available to switch to.
 * No polling, no download link — just a message and a button.
 */
export const UnplayableSourceOverlay = React.memo(function UnplayableSourceOverlay({ visible, message, onSwitchToProxy, }) {
    if (!visible)
        return null;
    return (_jsx("div", { className: "hekate-player-download-overlay hekate-player-download-overlay--visible", role: "alert", "aria-label": "Playback error", children: _jsxs("div", { className: "hekate-player-unplayable-source", children: [_jsx("h2", { className: "hekate-player-unplayable-source-title", children: "Unplayable file" }), _jsx("p", { className: "hekate-player-unplayable-source-message", children: message }), _jsx("button", { className: "hekate-player-switch-proxy-btn", onClick: onSwitchToProxy, type: "button", children: "Switch to Proxy" })] }) }));
});
